import api from 'utils/api';
import { toast } from 'utils/helpers';

const servicePath = '/services/recovery-price';

export const getAll = async (params) => {
  try {
    const response = await api.get(`${servicePath}`, { params });
    const records = response.data;

    return records;
  } catch (err) {
    console.log(err);
  }
}

export const getOne = async (id) => {
  try {
    const response = await api.get(`${servicePath}/${id}`);
    const record = response.data;

    return record;
  } catch (err) {
    console.log(err);
  }
}

export const createOne = async (details) => {
  try {
    const response = await api.post(`${servicePath}`, details);
    const record = response.data;

    return record;
  } catch (err) {
    console.log(err);
  }
}

export const updateOne = async (details) => {
  try {
    const response = await api.put(`${servicePath}/${details._id}`, details);
    const { record } = response.data;

    return record;
  } catch (err) {
    console.log(err);
  }
}

export const deleteOne = async (id) => {
  try {
    await api.delete(`${servicePath}/${id}`);
  } catch (err) {
    console.log(err);
  }
}

export const getTypes = async () => {
  try {
    const response = await api.post(`${servicePath}/get-types`);
    const types = response.data;
    
    return types;
  } catch (err) {
    console.log(err);
    toast('Nepavyko apdoroti užklausos. Bandykite dar kartą arba susisiekite su klientų aptarnavimu.', 'error');
  }
}

export const getVersions = async (params) => {
  try {
    const response = await api.post(`${servicePath}/get-versions`, params);
    const versions = response.data;
    
    return versions;
  } catch (err) {
    console.log(err);
    toast('Nepavyko apdoroti užklausos. Bandykite dar kartą arba susisiekite su klientų aptarnavimu.', 'error');
  }
}

export const getHierarchy = async (params) => {
  try {
    const response = await api.post(`${servicePath}/get-hierarchy`, params);
    const hierarchy = response.data;
    
    return hierarchy;
  } catch (err) {
    console.log(err);
  }
}

export const getFullHierarchy = async () => {
  try {
    const response = await api.post(`${servicePath}/get-full-hierarchy`);
    const hierarchy = response.data;
    
    return hierarchy;
  } catch (err) {
    console.log(err);
  }
}

export const getMaterials = async (params) => {
  try {
    const response = await api.post(`${servicePath}/get-materials`, params);
    const materials = response.data;
    
    return materials;
  } catch (err) {
    console.log(err);
  }
}

export const getCombinations = async (params) => {
  try {
    const response = await api.post(`${servicePath}/get-combinations`, params);
    const combinations = response.data;
    
    return combinations;
  } catch (err) {
    console.log(err);
  }
}

export const getCalculations = async (params) => {
  try {
    const response = await api.post(`${servicePath}/get-calculations`, params);
    const calculations = response.data;
    
    return calculations;
  } catch (err) {
    console.log(err);
  }
}

export const updateCalculations = async (params) => {
  try {
    const response = await api.post(`${servicePath}/update-calculations`, params);
    const calculations = response.data;
    
    return calculations;
  } catch (err) {
    console.log(err);
  }
}

/**
 * For NTK Viewer only.
 * 
 * @param {Object} params 
 */
export const getNtkPrices = async (params) => {
  try {
    const response = await api.post('/services/ntk/get-prices', params);
    const prices = response.data;
    
    return prices;
  } catch (err) {
    console.log(err);
  }
}

export const getFiles = async (params) => {
  try {
    const response = await api.post('/services/ntk/batch-download', params);
    const files = response.data;
    
    return files;
  } catch (err) {
    console.log(err);
  }
}

export const getExcelExport = async (params) => {
  try {
    const response = await api.post(`${servicePath}/export-excel`, params);
    const records = response.data;

    return records;
  } catch (err) {
    console.log(err);
  }
}